import { getEmbeddedLeadFormCta } from 'site-modules/shared/components/inventory/vdp-embedded-lead-form/vdp-embedded-lead-form';
import { isNew } from 'site-modules/shared/utils/inventory-utils/is-new';
import {
  isUsedDealCheckAvailable,
  isUsedNonPartnerDealerDealCheckAvailable,
} from 'site-modules/shared/utils/car-buying/is-used-deal-check-available';
import { get } from 'lodash-es';
import { getVdpCtas } from 'site-modules/shared/utils/inventory/get-vdp-ctas';

export const isTopEmbeddedLeadFormEnabled = (vinData, isSimulatedLeadForm, location) => {
  const ctas = getVdpCtas({ vinData, isSimulatedLeadForm, location });
  return !!getEmbeddedLeadFormCta(ctas);
};

const isUsedVdpPriceCheckerEnabled = ({ vinData, isUsedBasic, location }) => {
  const { maxGreatPrice, maxGoodPrice, maxFairPrice } = get(vinData, 'computedDisplayInfo.priceValidation', {});
  return (
    !isNew(vinData.type) &&
    !isUsedBasic &&
    get(vinData, 'historyInfo.cleanTitle', true) &&
    (isUsedDealCheckAvailable(vinData, location) || isUsedNonPartnerDealerDealCheckAvailable(vinData)) &&
    maxGreatPrice &&
    maxGoodPrice &&
    maxFairPrice &&
    !!get(vinData, 'computedDisplayInfo.priceValidation.listPriceEstimate', 0)
  );
};

const isNewVdpPriceCheckerEnabled = ({ vinData }) => {
  return (
    isNew(vinData.type) &&
    get(vinData, 'historyInfo.cleanTitle', true) &&
    !!get(vinData, 'vehicleInfo.styleInfo.styleId', '')
  );
};

export const buildLeadTargetPreloadEnabled = ({ vinData, isUsedBasic, location }) =>
  isTopEmbeddedLeadFormEnabled(vinData, false, location) ||
  isUsedVdpPriceCheckerEnabled({ vinData, isUsedBasic, location }) ||
  isNewVdpPriceCheckerEnabled({ vinData });
